import angular from 'angular';
import privacyConsentTable from './privacyConsentTable';

export default angular
  .module('component.privacyConsentTable', [])
  .component('privacyConsentTable', privacyConsentTable).name;
